import { render } from "./PanelProductOptionalInfo.vue?vue&type=template&id=55101aa9&scoped=true"
import script from "./PanelProductOptionalInfo.vue?vue&type=script&lang=js"
export * from "./PanelProductOptionalInfo.vue?vue&type=script&lang=js"

import "./PanelProductOptionalInfo.vue?vue&type=style&index=0&id=55101aa9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55101aa9"]])

export default __exports__